{
  "version": "1",
  "name": "Antiferromagnetic state",
  "device": "MockDevice",
  "register": [
    { "name": "q0", "x": -7.5, "y": -3.75 },
    { "name": "q1", "x": 0, "y": -3.75 },
    { "name": "q2", "x": 7.5, "y": -3.75 },
    { "name": "q3", "x": -7.5, "y": 3.75 },
    { "name": "q4", "x": 0, "y": 3.75 },
    { "name": "q5", "x": 7.5, "y": 3.75 }
  ],
  "channels": { "ising": "rydberg_global" },
  "variables": {},
  "operations": [
    {
      "op": "pulse",
      "protocol": "min-delay",
      "channel": "ising",
      "amplitude": { "kind": "ramp", "duration": 252, "start": 0, "stop": 14.451326206513047 },
      "detuning": { "kind": "constant", "duration": 252, "value": -37.69911184307752 },
      "phase": 0,
      "post_phase_shift": 0
    },
    {
      "op": "pulse",
      "protocol": "min-delay",
      "channel": "ising",
      "amplitude": { "kind": "constant", "duration": 800, "value": 14.451326206513047 },
      "detuning": {
        "kind": "ramp",
        "duration": 800,
        "start": -37.69911184307752,
        "stop": 28.274040025899872
      },
      "phase": 0,
      "post_phase_shift": 0
    },
    {
      "op": "pulse",
      "protocol": "min-delay",
      "channel": "ising",
      "amplitude": { "kind": "ramp", "duration": 500, "start": 14.451326206513047, "stop": 0 },
      "detuning": { "kind": "constant", "duration": 500, "value": 28.274 },
      "phase": 0,
      "post_phase_shift": 0
    }
  ],
  "measurement": "ground-rydberg"
}
